export const sugestions = ["gmail.com",
                            "outlook.com",
                            "icloud.com",
                            "hotmail.com",
                            "yahoo.com.br",
                            "bol.com.br",
                            "uol.com.br",
                            "msn.com",
                            "ig.com.br"]